declare namespace $ {

	type $giper_baza_unit_sand_dump__land_giper_baza_flex_field_1 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_field['land'] >
		,
		ReturnType< $giper_baza_unit_sand_dump['land'] >
	>
	type $giper_baza_unit_sand_dump__value_giper_baza_flex_field_2 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_field['link_value'] >
		,
		ReturnType< $giper_baza_unit_sand_dump['value'] >
	>
	type $mol_select__enabled_giper_baza_flex_field_3 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_field['enabled'] >
		,
		ReturnType< $mol_select['enabled'] >
	>
	type $mol_select__value_giper_baza_flex_field_4 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_field['link'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__options_giper_baza_flex_field_5 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_field['link_options'] >
		,
		ReturnType< $mol_select['options'] >
	>
	type $mol_select__option_label_giper_baza_flex_field_6 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_field['link_label'] >
		,
		ReturnType< $mol_select['option_label'] >
	>
	type $mol_select__Filter_giper_baza_flex_field_7 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_select['Filter'] >
	>
	type $mol_select__trigger_content_giper_baza_flex_field_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_select['trigger_content'] >
	>
	type $mol_select__value_giper_baza_flex_field_9 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_field['link_new'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__dictionary_giper_baza_flex_field_10 = $mol_type_enforce<
		({ 
			'local': string,
			'pull': string,
			'post': string,
			'read': string,
			'deny': string,
		}) 
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $giper_baza_flex_form__enabled_giper_baza_flex_field_11 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_field['enabled'] >
		,
		ReturnType< $giper_baza_flex_form['enabled'] >
	>
	type $giper_baza_flex_form__pawn_giper_baza_flex_field_12 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_field['dict_pawn'] >
		,
		ReturnType< $giper_baza_flex_form['pawn'] >
	>
	type $mol_select__enabled_giper_baza_flex_field_13 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_field['enabled'] >
		,
		ReturnType< $mol_select['enabled'] >
	>
	type $mol_select__value_giper_baza_flex_field_14 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_field['list_pick'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__options_giper_baza_flex_field_15 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_field['link_options'] >
		,
		ReturnType< $mol_select['options'] >
	>
	type $mol_select__option_label_giper_baza_flex_field_16 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_field['link_label'] >
		,
		ReturnType< $mol_select['option_label'] >
	>
	type $mol_button_minor__enabled_giper_baza_flex_field_17 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_field['enabled'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_giper_baza_flex_field_18 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_field['list_item_add'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_giper_baza_flex_field_19 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__enabled_giper_baza_flex_field_20 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_field['enabled'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_giper_baza_flex_field_21 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_field['list_item_paste'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_giper_baza_flex_field_22 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__sub_giper_baza_flex_field_23 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_bar__sub_giper_baza_flex_field_24 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_field['list_tools'] >
		,
		ReturnType< $mol_bar['sub'] >
	>
	type $mol_drop__adopt_giper_baza_flex_field_25 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_field['list_item_adopt'] >
		,
		ReturnType< $mol_drop['adopt'] >
	>
	type $mol_drop__receive_giper_baza_flex_field_26 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_field['list_receive'] >
		,
		ReturnType< $mol_drop['receive'] >
	>
	type $mol_drop__allow_giper_baza_flex_field_27 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_drop['allow'] >
	>
	type $mol_drop__Sub_giper_baza_flex_field_28 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_field['List_tools'] >
		,
		ReturnType< $mol_drop['Sub'] >
	>
	type $giper_baza_unit_sand_dump__land_giper_baza_flex_field_29 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_field['land'] >
		,
		ReturnType< $giper_baza_unit_sand_dump['land'] >
	>
	type $giper_baza_unit_sand_dump__sand_giper_baza_flex_field_30 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_field['list_item_sand'] >
		,
		ReturnType< $giper_baza_unit_sand_dump['sand'] >
	>
	type $giper_baza_unit_sand_dump__enabled_giper_baza_flex_field_31 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_field['enabled'] >
		,
		ReturnType< $giper_baza_unit_sand_dump['enabled'] >
	>
	type $mol_drag__end_giper_baza_flex_field_32 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_field['list_item_drag_end'] >
		,
		ReturnType< $mol_drag['end'] >
	>
	type $mol_drag__transfer_giper_baza_flex_field_33 = $mol_type_enforce<
		({ 
			'text/plain': ReturnType< $giper_baza_flex_field['list_item_text'] >,
			'text/html': ReturnType< $giper_baza_flex_field['list_item_html'] >,
			'text/uri-list': ReturnType< $giper_baza_flex_field['list_item_uri'] >,
		}) 
		,
		ReturnType< $mol_drag['transfer'] >
	>
	type $mol_drag__Sub_giper_baza_flex_field_34 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_field['List_item_dump'] >
		,
		ReturnType< $mol_drag['Sub'] >
	>
	type $mol_drop__adopt_giper_baza_flex_field_35 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_field['list_item_adopt'] >
		,
		ReturnType< $mol_drop['adopt'] >
	>
	type $mol_drop__receive_giper_baza_flex_field_36 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_field['list_item_receive'] >
		,
		ReturnType< $mol_drop['receive'] >
	>
	type $mol_drop__allow_giper_baza_flex_field_37 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_drop['allow'] >
	>
	type $mol_drop__Sub_giper_baza_flex_field_38 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_field['List_item_drag'] >
		,
		ReturnType< $mol_drop['Sub'] >
	>
	type $mol_list__rows_giper_baza_flex_field_39 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_field['list_items'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_select__enabled_giper_baza_flex_field_40 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_field['enabled'] >
		,
		ReturnType< $mol_select['enabled'] >
	>
	type $mol_select__value_giper_baza_flex_field_41 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_field['enum'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__options_giper_baza_flex_field_42 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_field['enum_options'] >
		,
		ReturnType< $mol_select['options'] >
	>
	type $mol_select__option_label_giper_baza_flex_field_43 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_field['enum_label'] >
		,
		ReturnType< $mol_select['option_label'] >
	>
	type $giper_baza_vary_edit__enabled_giper_baza_flex_field_44 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_field['enabled'] >
		,
		ReturnType< $giper_baza_vary_edit['enabled'] >
	>
	type $giper_baza_vary_edit__value_giper_baza_flex_field_45 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_field['atom_value'] >
		,
		ReturnType< $giper_baza_vary_edit['value'] >
	>
	type $giper_baza_vary_edit__schema_giper_baza_flex_field_46 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_field['schema'] >
		,
		ReturnType< $giper_baza_vary_edit['schema'] >
	>
	type $giper_baza_vary_edit__selection_giper_baza_flex_field_47 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_field['atom_selection'] >
		,
		ReturnType< $giper_baza_vary_edit['selection'] >
	>
	type $mol_bar__sub_giper_baza_flex_field_48 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_field['link_content'] >
		,
		ReturnType< $mol_bar['sub'] >
	>
	type $mol_textarea__enabled_giper_baza_flex_field_49 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_field['enabled'] >
		,
		ReturnType< $mol_textarea['enabled'] >
	>
	type $mol_textarea__value_giper_baza_flex_field_50 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_field['str'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_textarea__selection_giper_baza_flex_field_51 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_field['str_selection'] >
		,
		ReturnType< $mol_textarea['selection'] >
	>
	type $mol_date__enabled_giper_baza_flex_field_52 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_field['enabled'] >
		,
		ReturnType< $mol_date['enabled'] >
	>
	type $mol_date__value_moment_giper_baza_flex_field_53 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_field['time'] >
		,
		ReturnType< $mol_date['value_moment'] >
	>
	type $mol_expander__title_giper_baza_flex_field_54 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_field['dict_title'] >
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__content_giper_baza_flex_field_55 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	type $mol_textarea__enabled_giper_baza_flex_field_56 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_field['enabled'] >
		,
		ReturnType< $mol_textarea['enabled'] >
	>
	type $mol_textarea__value_giper_baza_flex_field_57 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_field['text'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_textarea__selection_giper_baza_flex_field_58 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_field['text_selection'] >
		,
		ReturnType< $mol_textarea['selection'] >
	>
	type $giper_baza_rich_edit__enabled_giper_baza_flex_field_59 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_field['enabled'] >
		,
		ReturnType< $giper_baza_rich_edit['enabled'] >
	>
	type $giper_baza_rich_edit__pawn_giper_baza_flex_field_60 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_field['rich_pawn'] >
		,
		ReturnType< $giper_baza_rich_edit['pawn'] >
	>
	type $mol_list__rows_giper_baza_flex_field_61 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	export class $giper_baza_flex_field extends $mol_view {
		Sub( ): $mol_view
		enabled( ): boolean
		enum( next?: any ): any
		enum_options( ): readonly(any)[]
		enum_label( id: any): string
		atom_value( next?: any ): any
		schema( ): any
		atom_selection( next?: readonly(any)[] ): readonly(any)[]
		link_value( ): any
		Link_dump( ): $giper_baza_unit_sand_dump
		link( next?: any ): any
		link_options( ): readonly(any)[]
		link_label( id: any): string
		Link_pick( ): $mol_select
		Link_new_icon( ): $mol_icon_plus
		link_new( next?: any ): any
		Link_new( ): $mol_select
		link_content( ): readonly(any)[]
		str( next?: string ): string
		str_selection( next?: readonly(any)[] ): readonly(any)[]
		time( next?: $mol_time_moment ): $mol_time_moment
		dict_title( ): string
		dict_pawn( ): $giper_baza_dict
		Dict_form( ): $giper_baza_flex_form
		text( next?: string ): string
		text_selection( next?: readonly(any)[] ): readonly(any)[]
		rich_pawn( next?: $giper_baza_rich ): $giper_baza_rich
		list_item_adopt( next?: any ): any
		list_receive( next?: any ): any
		list_pick( next?: any ): any
		List_pick( ): $mol_select
		list_item_add( next?: any ): any
		List_item_add( ): $mol_button_minor
		list_item_paste( next?: any ): any
		List_item_paste_icon( ): $mol_icon_content_paste
		List_item_paste( ): $mol_button_minor
		list_tools( ): readonly(any)[]
		List_tools( ): $mol_bar
		List_drop( ): $mol_drop
		list_item_receive( id: any, next?: any ): any
		list_item_drag_end( id: any, next?: any ): any
		list_item_text( id: any): string
		list_item_html( id: any): string
		list_item_uri( id: any): string
		list_item_sand( id: any): $giper_baza_unit_sand
		List_item_dump( id: any): $giper_baza_unit_sand_dump
		List_item_drag( id: any): $mol_drag
		List_item_drop( id: any): $mol_drop
		List_item( id: any): ReturnType< $giper_baza_flex_field['List_item_drop'] >
		list_items( ): readonly(any)[]
		List_items( ): $mol_list
		sub( ): readonly(any)[]
		pawn( next?: $giper_baza_pawn ): $giper_baza_pawn
		land( ): ReturnType< ReturnType< $giper_baza_flex_field['pawn'] >['land'] >
		prop( ): $giper_baza_flex_prop
		Enum( ): $mol_select
		Atom( ): $giper_baza_vary_edit
		Ref( ): $mol_bar
		Str( ): $mol_textarea
		Time( ): $mol_date
		Dict( ): $mol_expander
		Text( ): $mol_textarea
		Rich( ): $giper_baza_rich_edit
		List( ): $mol_list
	}
	
}

//# sourceMappingURL=field.view.tree.d.ts.map